<div class="header-container">
  <div class="header-content">
    <div class="row align-items-center">
      <div class="col-md-8">
        <div *ngIf="title !== ''" class="header-text">
          {{ title }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="button-container">
          <lib-reactive-form-group class="w-100">
            <lib-reactive-form-text [inputName]="'search'" placeholder="Search" i18n-placeholder />
          </lib-reactive-form-group>
          <lib-button-neutral
            [iconSrc]="'assets/icons/dark/List.svg'"
            (buttonClicked)="rearrangeButtonClicked.emit()"
            i18n>
            Rearrange
          </lib-button-neutral>
        </div>
      </div>
    </div>
  </div>
</div>
